export class UserServiceRightConfig {
  public userId: number;
  public serviceId: number;
  public roleId?: number;
  public roleNonEcrasableParProfil?: boolean;
  public profilsAssocies?: number[];
  public rights: {
    herResponsableService?: boolean;
    herResponsableClassement?: boolean;
    herResponsableDistribution?: boolean;
    herValidationDistribution?: boolean;
    herAccesDocumentConfidentiel?: boolean;
    herSupprimerDocument?: boolean;
    herRepondreALaPlaceDe?: boolean;
    herRefuserCreationDocumentEntrant?: boolean;
    herRefuserCreationDocumentSortant?: boolean;
    herRefuserModification?: boolean;
    herInterdireRepondreDocument?: boolean;
    herRefuserAjoutDistribution?: boolean;
    herRefuserAjoutFichier?: boolean;
    herRefuserSuppressionFichier?: boolean;
    herRefuserAjoutVersionFichier?: boolean;
    herRefuserVisualisationVersionFichier?: boolean;
    herRefuserModificationFichier?: boolean;
    herRefuserVisualisationFichier?: boolean;
    herCacherStatutMultiple?: boolean;
    herCacherFichier?: boolean;
    herRefuserMauvaisRoutage?: boolean;
    herAccesMauvaisRoutage?: boolean;
    herAccesRetourCourrier?: boolean;
    herAccesStatistique?: boolean;
    responsableService?: boolean;
    responsableClassement?: boolean;
    responsableDistribution?: boolean;
    validationDistribution?: boolean;
    AccesDocumentConfidentiels?: boolean;
    supprimerDocument?: boolean;
    repondreALaPlaceDe?: boolean;
    refuserCreationDocumentEntrant?: boolean;
    refuserCreationDocumentSortant?: boolean;
    refuserModification?: boolean;
    interdireRepondreDocument?: boolean;
    refuserAjoutDistribution?: boolean;
    refuserAjoutFichier?: boolean;
    refuserSuppressionFichier?: boolean;
    refuserAjoutVersionFichier?: boolean;
    RefuserVisualisationVersionFichiers?: boolean;
    refuserModificationFichier?: boolean;
    refuserVisualisationFichier?: boolean;
    cacherStatutMultiples?: boolean;
    cacherFichiers?: boolean;
    refuserMauvaisRoutage?: boolean;
    accesMauvaisRoutage?: boolean;
    AccesRetourCourriers?: boolean;
    AccesStatistiques?: boolean;
  };

  constructor(data?) {
    Object.assign(this, data);
  }
}
